import * as React from "react";
import {Button, Header, List, Modal} from 'semantic-ui-react';
import {authentication} from "../../../authentication";
import {Company} from "../../../generated/api";
import {backend} from "../../../xconvert-backend";
import {ListSelectModal} from "../list_select_modal";
import {ConfigContext} from "../../main/context/ConfigContext";
import {LeaveWithChangesModal} from "../../main/pages/configChange/configEdit/modals/LeaveWithChangesModal";
import {workingConfig} from "../../main/pages/configChange/ConfigSignal";
import {IfBox} from "../../style/if";

export interface SelectCompanyModalProps {
    onClose: () => (void)
    onSelect: (c: Company) => (Promise<void>)
    open: boolean
    forCompanyChange: boolean
    forcedCompany?: Company
}

export class SelectCompanyModal extends React.Component<SelectCompanyModalProps, any> {
    constructor(props) {
        super(props)
        this.state = {
            isSelecting: false,
            showConfigChangedModal: false,
            selectedCompany: null,
            currentCompanyConfig: null,
            failedTests: []
        }
    }

    static contextType = ConfigContext
    context!: React.ContextType<typeof ConfigContext>;

    renderItem = (c: Company, searchTerm?: string) => {
        const tag = c.tag || null;
        const lowerSearch = (searchTerm || '').toLowerCase();
        let tagDisplay: React.ReactNode = tag;

        if (tag && lowerSearch && tag.toLowerCase().includes(lowerSearch)) {
            const start = tag.toLowerCase().indexOf(lowerSearch);
            const end = start + lowerSearch.length;

            const before = tag.slice(0, start);
            const match = tag.slice(start, end);
            const after = tag.slice(end);

            tagDisplay = (
                <>
                    {before}
                    <mark style={{backgroundColor: 'yellow', padding: '0 2px', borderRadius: '2px'}}>{match}</mark>
                    {after}
                </>
            );
        }

        return (
            <List.Content>
                <List.Header>{c.name}</List.Header>
                <IfBox shouldShow={c.address != null} else={
                    <List.Description>keine Adresse</List.Description>
                }> <List.Description>
                    {(c.address?.street || "")} {(c.address?.houseNumber || "")}<br/>
                    {(c.address?.country || "")} - {(c.address?.city || "")}
                </List.Description>
                </IfBox>
                {tag && (
                    <List.Description style={{marginTop: '4px'}}>
                        <span>{tagDisplay}</span>
                    </List.Description>
                )}
            </List.Content>
        );
    }

    onSearch = async (q: string, includeArchived: boolean = false) => {
        let authHeader = backend.withTokenAuthHeader(authentication.token)
        let res = await backend.companyApi.queryCompanies(q, includeArchived, authHeader)
        return res.results
    }

    onClose = () => {
        this.props.onClose()
    }

    onSelect = async (c: Company) => {
        this.setState({isSelecting: true})
        await this.props.onSelect(c)
        this.setState({isSelecting: false})
    }

    checkIfConfigChanged = async (c: Company) => {
        console.log("checking if Config has changed")

        if (workingConfig.value == null) {
            // no changes possible!
            this.onSelect(c)
            return
        }

        let auth = (await backend.withTokenAuthHeader(authentication.token))

        let currentCompanyConfig = (await backend.internalApi.fetchCompanyConfiguration(this.context.companyId, auth))


        // check if there are unsaved changes on the config
        if (workingConfig.value != JSON.stringify(currentCompanyConfig, null, 4)) {
            console.log("Config has changed")

            this.setState({
                showConfigChangedModal: this.props.forCompanyChange,
                selectedCompany: c,
                currentCompanyConfig: currentCompanyConfig
            })
        } else {
            this.onSelect(c)
        }
    }

    onDecision(decision: LeaveWithChangeDecision) {

        switch (decision) {
            case LeaveWithChangeDecision.SAVE:
                this.onSelect(this.state.selectedCompany)
                break;
            case LeaveWithChangeDecision.SAVE_AS_DRAFT:
                this.onSelect(this.state.selectedCompany)
                break;
            case LeaveWithChangeDecision.KEEP_IN_STORAGE:
                this.onSelect(this.state.selectedCompany)
                break;
            case LeaveWithChangeDecision.DISCARD:
                this.onSelect(this.state.selectedCompany)
                break;
            case LeaveWithChangeDecision.CANCEL:
                break;
            default:

        }
    }

    render() {
        if (this.props.forcedCompany != null) {
            return <Modal
                open={this.props.open}
                onClose={this.onClose}
                dimmer="blurring"
                size='large'
            >
                <Header icon='browser' content={'Switch to : ' + this.props.forcedCompany.name}/>
                <Modal.Content>
                    Are you sure, you want to switch to {this.props.forcedCompany.name}?

                    <Button
                        id='SelectCompanyModalForcedSwitchButton'
                        onClick={() => this.checkIfConfigChanged(this.props.forcedCompany)}
                        loading={this.state.isSelecting}
                        disabled={this.state.isSelecting}
                    >
                        Switch
                    </Button>

                    <Button
                        id='SelectCompanyModalForcedCancelButton'
                        onClick={() => this.onClose()}
                        disabled={this.state.isSelecting}
                    >
                        Cancel
                    </Button>
                </Modal.Content>
                <LeaveWithChangesModal
                    isOpen={this.state.showConfigChangedModal}
                    onClose={() => {
                        this.setState({showConfigChangedModal: false})
                    }}
                    dispatcher={(decision: LeaveWithChangeDecision) => {
                        this.onDecision(decision)
                    }}
                    currentCompanyConfig={this.state.currentCompanyConfig}
                />
            </Modal>
        }

        return <div>
            <ListSelectModal<Company>
                open={this.props.open}
                renderItem={this.renderItem}
                onSearch={this.onSearch}
                onSelect={this.checkIfConfigChanged}
                onClose={this.onClose}
                isSelectingItem={this.state.isSelecting}
                enableKeyboardNavigation={true}
            />
            <LeaveWithChangesModal
                isOpen={this.state.showConfigChangedModal}
                onClose={() => {
                    this.setState({showConfigChangedModal: false})
                }}
                dispatcher={(decision: LeaveWithChangeDecision) => {
                    this.onDecision(decision)
                }}
                currentCompanyConfig={this.state.currentCompanyConfig}
            />

        </div>
    }
}

export enum LeaveWithChangeDecision {
    SAVE = "Save",
    SAVE_AS_DRAFT = "SaveAsDraft",
    CANCEL = "Cancel",
    KEEP_IN_STORAGE = "KeepInStorage",
    DISCARD = "Discard"
}
